import { CenterDataForm, CenterFilters } from '../../../../app/models/Center';
import { DepotDataForm, DepotFilters } from '../../../../app/models/Depot';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import DepotSwitchChange from '../DepotSwitchChange';
import DepotFilter from './DepotFilter';

interface Props {
    depots: DepotDataForm[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: DepotFilters;
    setFilter: (filter: DepotFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
}

const DepotDataTable = ({
    depots,
    totalRows,
    loading = false,
    edit,
    destroy,
    show,
    filter,
    setFilter,
    callbackSuccess
}: Props) => {
    const columns = [
        {
            name: 'Id',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            cell: (row: DepotDataForm, index: any, column: any) => (
                <span className="">{row.id}</span>
            )
        },
        {
            name: 'Nombre',
            selector: (row: any) => row.business_name,
            sortable: true,
            sortField: 'name',
            cell: (row: DepotDataForm, index: any, column: any) => (
                <span className="">{row.name}</span>
            )
        },
        {
            name: 'Centro',
            selector: (row: any) => row.center,
            sortable: true,
            sortField: 'center',
            cell: (row: DepotDataForm, index: any, column: any) => (
                <span className="">{row.center}</span>
            )
        },
        {
            name: 'Supervisor',
            selector: (row: any) => row.supervisor,
            sortable: true,
            sortField: 'supervisor',
            cell: (row: DepotDataForm, index: any, column: any) => {
                return (
                    <div>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: row.supervisor ? row.supervisor : ''
                            }}
                        />
                    </div>
                );
            }
        },
        {
            name: 'Es propio',
            selector: (row: any) => row.business_name,
            sortable: true,
            sortField: 'name',
            cell: (row: DepotDataForm, index: any, column: any) => (
                <span className="">{row.is_owner}</span>
            )
        },
        {
            name: 'Activo',
            selector: (row: any) => row.is_active,
            sortable: true,
            sortField: 'is_active',
            cell: (row: DepotDataForm, index: any, column: any) => (
                <DepotSwitchChange
                    checkValue={row.is_active ?? true}
                    depotId={row.id!}
                    callbackSuccess={callbackSuccess!}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: DepotDataForm, index: any, column: any) => (
                <div className="">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <DepotFilter filter={filter} setFilter={setFilter} />
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={depots}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default DepotDataTable;
